module.exports = __webpack_public_path__ + "assets/71fb79dbca83542865518f162c51c796.woff2";